(function(){

function animate(container){
  const blocos = container.querySelectorAll('.ym-bloco');
  blocos.forEach(b=>b.classList.remove('show'));

  void container.offsetHeight;

  blocos.forEach((b,i)=>{
    setTimeout(()=>b.classList.add('show'), i*120);
  });
}

function init(){

  const wrapper = document.querySelector('.ym-wrapper');
  if(!wrapper) return;

  const tabs = wrapper.querySelectorAll('.ym-tab');
  const contents = wrapper.querySelectorAll('.ym-content');

  tabs.forEach(tab=>{
    tab.addEventListener('click', function(){

      tabs.forEach(t=>t.classList.remove('active'));
      contents.forEach(c=>c.classList.remove('active'));

      this.classList.add('active');

      const el = wrapper.querySelector(`[data-content="${this.dataset.tab}"]`);

      if(el){
        el.classList.add('active');
        animate(el);
      }

    });
  });

  /* GUIA */

  const guideTabs = wrapper.querySelectorAll('.ym-guide-tab');
  const guideContents = wrapper.querySelectorAll('.ym-guide-content');

  guideTabs.forEach(tab=>{
    tab.addEventListener('click', function(){

      guideTabs.forEach(t=>t.classList.remove('active'));
      guideContents.forEach(c=>c.classList.remove('active'));

      this.classList.add('active');

      const el = wrapper.querySelector(
        `[data-guide-content="${this.dataset.guide}"]`
      );

      if(el) el.classList.add('active');

    });
  });

  const active = wrapper.querySelector('.ym-content.active');

  if(active) animate(active);

}

document.addEventListener('DOMContentLoaded', init);

})();


/* =========================
   POPUP STEP-BY-STEP
   CALCULADORA DE TAMANHO
========================= */

(function(){

let stepIndex = 0;

const steps = [
  "busto",
  "cintura",
  "quadril"
];

let data = {
  busto:null,
  cintura:null,
  quadril:null
};

const popup = document.getElementById("ym-popup");

/* GARANTE QUE NÃO ABRA AO CARREGAR */

if(popup){
  popup.classList.remove("active");
}


/* =========================
   EVENTOS
========================= */

document.addEventListener("click", function(e){

  /* ABRIR POPUP */

  if(e.target.closest(".ym-discover-btn")){
    openPopup();
  }


  /* FECHAR POPUP */

  if(
    e.target.closest(".ym-popup-close") ||
    e.target.classList.contains("ym-popup-overlay")
  ){
    closePopup();
  }


  /* PRÓXIMO */

  if(e.target.closest(".ym-next")){

    if(!validate()) return;

    save();

    stepIndex++;

    if(stepIndex < steps.length){

      render();

    }else{

      showResult();

    }

  }


  /* REFAZER */

  if(e.target.closest(".ym-restart")){

    reset();
    render();

  }

});


/* =========================
   ABRIR POPUP
========================= */

function openPopup(){

  if(!popup) return;

  popup.classList.add("active");

  document.body.style.overflow = "hidden";

  reset();

  render();

}


/* =========================
   FECHAR POPUP
========================= */

function closePopup(){

  if(!popup) return;

  popup.classList.remove("active");

  document.body.style.overflow = "";

}


/* =========================
   RENDER DAS PERGUNTAS
========================= */

function render(){

  const field = steps[stepIndex];

  const container = document.querySelector(".ym-inputs");

  const title = document.querySelector(
    '[data-step="2"] .ym-step-title'
  );

  if(!container || !title) return;

  let label = "";

  if(field === "busto"){
    label = "Qual seu busto? (cm)";
  }

  if(field === "cintura"){
    label = "Qual sua cintura? (cm)";
  }

  if(field === "quadril"){
    label = "Qual seu quadril? (cm)";
  }

  title.innerText = label;

  container.innerHTML = `
    <input
      type="number"
      class="ym-field"
      placeholder="Digite a medida"
      min="1"
      step="0.1"
    >

    <span class="ym-error">
      Preencha corretamente
    </span>
  `;

  setTimeout(()=>{

    const input = container.querySelector(".ym-field");

    if(input){
      input.focus();
    }

  },100);

}


/* =========================
   VALIDAÇÃO
========================= */

function validate(){

  const container = document.querySelector(".ym-inputs");

  if(!container) return false;

  const input = container.querySelector(".ym-field");

  const error = container.querySelector(".ym-error");

  if(!input || !error) return false;

  const value = parseFloat(
    String(input.value).replace(",", ".")
  );

  if(!value || value <= 0){

    input.classList.add("error");

    error.classList.add("active");

    return false;

  }

  input.classList.remove("error");

  error.classList.remove("active");

  return true;

}


/* =========================
   SALVAR MEDIDA
========================= */

function save(){

  const input = document.querySelector(
    ".ym-inputs .ym-field"
  );

  if(!input) return;

  const value = parseFloat(
    String(input.value).replace(",", ".")
  );

  data[steps[stepIndex]] = value;

}


/* =========================
   RESULTADO
========================= */

function showResult(){

  const {
    busto,
    cintura,
    quadril
  } = data;


  /* =========================
     NOVA TABELA DE MEDIDAS

     PP
     Busto: 66 cm
     Cintura: 58 cm
     Quadril: 76 cm

     P
     Busto: 68 cm
     Cintura: 60 cm
     Quadril: 78 cm

     M
     Busto: 70 cm
     Cintura: 62 cm
     Quadril: 80 cm

     G
     Busto: 72 cm
     Cintura: 64 cm
     Quadril: 82 cm
  ========================= */

  const tabela = [

    {
      tamanho:"PP",
      busto:66,
      cintura:58,
      quadril:76
    },

    {
      tamanho:"P",
      busto:68,
      cintura:60,
      quadril:78
    },

    {
      tamanho:"M",
      busto:70,
      cintura:62,
      quadril:80
    },

    {
      tamanho:"G",
      busto:72,
      cintura:64,
      quadril:82
    }

  ];


  /* =========================
     CALCULA TAMANHO MAIS
     PRÓXIMO DAS 3 MEDIDAS
  ========================= */

  let melhor = tabela[0];

  let menorErro = Infinity;


  tabela.forEach(item => {

    const erroBusto =
      Math.abs(busto - item.busto);

    const erroCintura =
      Math.abs(cintura - item.cintura);

    const erroQuadril =
      Math.abs(quadril - item.quadril);


    const erroTotal =
      erroBusto +
      erroCintura +
      erroQuadril;


    if(erroTotal < menorErro){

      menorErro = erroTotal;

      melhor = item;

    }

  });


  /* =========================
     MOSTRA RESULTADO
  ========================= */

  const resultEl =
    document.querySelector(".ym-result");


  if(resultEl){

    resultEl.innerText =
      melhor.tamanho;

  }


  const step2 =
    document.querySelector(
      '[data-step="2"]'
    );

  const step3 =
    document.querySelector(
      '[data-step="3"]'
    );


  if(step2){
    step2.style.display = "none";
  }

  if(step3){
    step3.style.display = "block";
  }

}


/* =========================
   RESET
========================= */

function reset(){

  stepIndex = 0;

  data = {
    busto:null,
    cintura:null,
    quadril:null
  };


  const step2 =
    document.querySelector(
      '[data-step="2"]'
    );

  const step3 =
    document.querySelector(
      '[data-step="3"]'
    );


  if(step2){
    step2.style.display = "block";
  }

  if(step3){
    step3.style.display = "none";
  }

}

})();


/* =========================
   WHATSAPP
========================= */

document.addEventListener("click", function(e){

  const btn =
    e.target.closest(
      ".ym-whatsapp-trigger"
    );

  if(!btn) return;


  const overlay =
    document.getElementById(
      "pw-overlay"
    );

  const drawer =
    document.getElementById(
      "pw-drawer"
    );


  if(overlay && drawer){

    overlay.style.display =
      "block";

    drawer.classList.add(
      "open"
    );

  }

});